import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  Chip
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const RecordViewModal = ({ open, onClose, employee }) => {
  // Mock data for the employee's time records
  const timeRecords = [
    {
      date: 'Sep 15, 2025 - Monday',
      schedule: '08:00 am to 05:00 pm',
      timeIn: '07:52 am',
      timeOut: '05:06 pm',
      workingHrs: '9.23 hrs',
      lates: '407.87 hrs',
      undertime: 'Undertime',
      overtime: 'Overtime',
      nightDiff: '0 hrs'
    },
    {
      date: 'Sep 16, 2025 - Tuesday',
      schedule: '08:00 am to 05:00 pm',
      timeIn: '07:50 am',
      timeOut: '07:13 pm',
      workingHrs: '11.38 hrs',
      lates: '431.83 hrs',
      undertime: 'Undertime',
      overtime: 'Overtime',
      nightDiff: '0 hrs'
    },
    {
      date: 'Sep 17, 2025 - Wednesday',
      schedule: '08:00 am to 05:00 pm',
      timeIn: '07:52 am',
      timeOut: '05:47 pm',
      workingHrs: '9.92 hrs',
      lates: '455.87 hrs',
      undertime: 'Undertime',
      overtime: 'Overtime',
      nightDiff: '0 hrs'
    }
  ];

  if (!employee) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1,
        borderBottom: '1px solid #e5e7eb'
      }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600, color: '#374151' }}>
          Record - {employee.id}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: '#6b7280',
            '&:hover': { bgcolor: '#f3f4f6' }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3, borderBottom: '1px solid #e5e7eb' }}>
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#374151' }}>
            {employee.id} - {employee.name}
          </Typography>
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Date
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Schedule
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Time In
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Time Out
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Working Hrs
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Lates
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Undertime
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  borderRight: '1px solid #e0e0e0'
                }}>
                  Overtime
                </TableCell>
                <TableCell sx={{ 
                  fontWeight: 600, 
                  bgcolor: '#f9fafb',
                  color: '#374151',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  Night Diff
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeRecords.map((record, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:nth-of-type(even)': {
                      backgroundColor: '#f8f9fa'
                    },
                    '&:hover': {
                      backgroundColor: '#f0f0f0'
                    },
                    '& > .MuiTableCell-root': {
                      borderRight: '1px solid #e0e0e0',
                      borderBottom: '1px solid #e0e0e0'
                    },
                    '& > .MuiTableCell-root:last-child': {
                      borderRight: 'none'
                    }
                  }}
                >
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {record.date}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {record.schedule}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {record.timeIn}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {record.timeOut}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#059669' }}>
                      {record.workingHrs}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#dc2626' }}>
                      {record.lates}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={record.undertime}
                      size="small"
                      sx={{
                        bgcolor: '#fef2f2',
                        color: '#dc2626',
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        height: '24px'
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={record.overtime}
                      size="small"
                      sx={{
                        bgcolor: '#f0f9ff',
                        color: '#0369a1',
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        height: '24px'
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {record.nightDiff}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: '1px solid #e5e7eb' }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: '#e5e7eb',
            color: '#6b7280',
            textTransform: 'none',
            px: 3,
            py: 1,
            '&:hover': {
              borderColor: '#12C1DC',
              color: '#12C1DC'
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecordViewModal;
